<template>
  <div class="d-flex">
    <!-- <component :is="service"></component> -->
    <router-view></router-view>
  </div>
</template>
<script>
import GKE from './gke/index';

import { URL_MAP } from '../util';
export default {
  name: 'GCP',
  components: {
    GKE
  },
  data() {
    return {};
  },
  props: {
    service: {
      type: String,
      default: URL_MAP.DEFAULT.SERVICE.toUpperCase(),
      required: true
    }
  }
};
</script>
<style scoped></style>
